import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { roleId, unixId } = useSelector(
    (state) => state?.Auth?.userClaimObject
  );
  if (!roleId || !unixId) {
    return (
      <Navigate
        to='/roleSelection'
        replace
      />
    );
  }
  return children || <Outlet />;
};

export default ProtectedRoute;
